import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {ConnectedInput} from "../../../components/Form/ConnectedInput.tsx";
import {ConnectedTimePicker} from "../../../components/Form/ConnectedTimePicker.tsx";
import {ConnectedSelect} from "../../../components/Form/ConnectedSelect.tsx";
import {
    useCreateSurchargeTimeDefinitionMutation,
    useLazyOneSurchargeTimeDefinitionQuery,
    useUpdateSurchargeTimeDefinitionMutation
} from "../../../api/surcharge.slice.ts";
import {useEffect, useState} from "react";
import {Button} from "../../../components/Button.tsx";
import {DataLoadingError} from "../../../components/DataLoadingError.tsx";
import {SERVER_VALIDATION_ERRORS} from "../../../components/Form/CONSTANTS.ts";

type Inputs = {
    name: string;
    startTime: string,
    endTime: string,
    dayOfWeek: string
}

type SurchargeTimeDefinitionFormProps = {
    id?: string
    onCancel: () => void
}

//TODO This should be based on a generic connected form component. This would be way to much boilerplate to repeat every time
export const SurchargeTimeDefinitionForm = ({id, onCancel}: SurchargeTimeDefinitionFormProps) => {
    const [trigger, {data, isLoading, error}] = useLazyOneSurchargeTimeDefinitionQuery()
    const [isEditMode, setEditMode] = useState(false)
    const [isSubmitting, setSubmitting] = useState(false)

    const [createDefinition] = useCreateSurchargeTimeDefinitionMutation()
    const [updateDefinition] = useUpdateSurchargeTimeDefinitionMutation()

    const methods = useForm<Inputs>({
        values: data ? {...data} : undefined,
    })

    const onSubmit: SubmitHandler<Inputs> = (data) => {

        const action = isEditMode ? updateDefinition : createDefinition

        setSubmitting(true)
        action({...data, id: id!})
            .unwrap()
            .then(result => console.log("a", result))
            .catch(err => {
                if (err.status === 400) {
                    for (const [key, value] of Object.entries(err?.data.violations)) {
                        //Can't really think of a good way to type this. The api response is just "Trust me bro"
                        methods.setError(key as unknown as any, {
                            types: {
                                [SERVER_VALIDATION_ERRORS]: value as unknown as Array<string>
                            }
                        })
                    }
                }
            })
            .finally(() => setSubmitting(false))
    }

    useEffect(() => {
        if (id) {
            setEditMode(true)
            trigger(id)
        }
    }, [id])


    const handleSubmit = methods.handleSubmit

    const WEEKDAY = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"]


    return (
        <DataLoadingError isLoading={isLoading} error={error}>
            <FormProvider {...methods}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <ConnectedInput name="name" label="Name" type={"text"}/>
                    <div className="display-grid grid-cols-2 gap-20">
                        <ConnectedTimePicker name="startTime" label="Start Time"/>
                        <ConnectedTimePicker name="endTime" label="End Time"/>
                    </div>
                    <ConnectedSelect name="dayOfWeek" label="Weekday"
                                     options={WEEKDAY.map((x) => ({id: x, label: x}))}/>

                    <div className="btn-toolbar" style={{display: "flex", flexDirection: "row-reverse"}}>

                        <Button isLoading={isSubmitting} type={"submit"}>{isEditMode ? "Update" : "Create"}</Button>
                        <Button disabled={isSubmitting} onClick={(event) => {
                            event.preventDefault()
                            onCancel()
                        }}>Cancel</Button>
                    </div>
                </form>
            </FormProvider>
        </DataLoadingError>
    )

}